import { Button, DatePicker, Input, Modal, Table } from 'antd';
import dayjs from 'dayjs';
import React, { useState } from 'react';
interface ScanItem {
  barcode: string;
  scanDate: string;
}
interface Props {
  list: any[];
  onInsert: (code: string) => void;
  onRemove?: any;
  onChange?: any;
  open?: boolean;
}
export const ScanModal = ({ open, list, onInsert }: Props) => {
  const [code, changeCode] = useState('');
  const submitCode = () => {};
  const onKeydown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      const result = code.replace(/\s+/g, '').toUpperCase();
      if (result.length > 12) {
        onInsert(result);
      } else {
        changeCode(result);
      }
    }
  };
  const columns = [
    {
      title: '#',
      render: (val: any, row: any) => <span>{row.index}</span>,
    },
    {
      title: 'code',
      width: '100',
      render: (val: any, row: any) => <span>{row.code}</span>,
    },
    {
      title: 'scanDate',
      width: '100',
      render: (val: any, row: any) => (
        <span>
          <DatePicker
            showTime
            onChange={(value, dateString) => {
              console.log('Selected Time: ', value);
              console.log('Formatted Selected Time: ', dateString);
            }}
          />
          {row.scanDate != '' ? dayjs(row.scanDate).format('YYYY-MM-DD HH:mm:ss') : ''}
          <div style={{ color: 'red', fontSize: 10 }}>{row.message ? row.message : null}</div>
        </span>
      ),
    },
  ];
  return (
    <Modal
      width={500}
      className="scan-modal"
      title="Скан хийх"
      maskClosable={false}
      open={open}
      // onCancel={() => this.handleCancel()}
      footer={[<Button type="primary">Хадгалах</Button>, <Button>Хаах</Button>]}
    >
      <Input
        value={code}
        onChange={(e) => changeCode(e.target.value)}
        onKeyDown={onKeydown}
        autoFocus={true}
        placeholder="___-____-___"
      />
      <Table
        rowKey={(record) => 'scan' + record.index}
        columns={columns}
        showHeader={false}
        size={'small'}
        pagination={false}
        dataSource={list}
      />
    </Modal>
  );
};
